module.exports = __webpack_public_path__ + "media/images/groupRank__eval--correct@3x-a1a9aeae5e85601b6537366a9390f23d.png";